import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ClassAPI } from '../../api/class-api';
import loadinglogo from '../../img/loading.gif';

const PermissionForClass = ({ children }: { children: JSX.Element }) => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const res = await ClassAPI.hasPermissionForClass(id);
        if (res.data) {
          setAllowed(true);
        } else {
          toast.error("You do not have permission to view this class.");
          history.push("/admin/search/class");
        }
      } catch (err) {
        toast.error("Permission check failed.");
        history.push("/admin/search/class")
      } finally {
        setLoading(false);
      }
    };
    checkPermission();
  }, [id, history]);

  if (loading) return (
    <div style={{ textAlign: "center" }}>
      <img src={loadinglogo} width="30" height="30" className="d-inline-block align-top" alt="Loading..." />
    </div>
  );
  return allowed ? children : null;

};

export default PermissionForClass;